import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCode, FiBox, FiZap } from 'react-icons/fi';

const Features = () => {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-black text-slate-900 mb-4">Built for Creators</h2>
          <p className="text-slate-500">Everything you need to add professional football data to your site.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center px-4">
            <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiZap} className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Instant Setup</h3>
            <p className="text-slate-600 text-sm leading-relaxed">
              No complex coding needed. Copy your custom snippet and watch your site come to life with live data.
            </p>
          </div>
          
          <div className="text-center px-4">
            <div className="w-16 h-16 bg-brand-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiBox} className="w-8 h-8 text-brand-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Fully Custom</h3>
            <p className="text-slate-600 text-sm leading-relaxed">
              Style your widgets to match your project perfectly. Colors, fonts, and layouts are all in your control.
            </p>
          </div>
          
          <div className="text-center px-4">
            <div className="w-16 h-16 bg-purple-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiCode} className="w-8 h-8 text-purple-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">No Maintenance</h3>
            <p className="text-slate-600 text-sm leading-relaxed">
              We handle the data feeds and server uptime. You just focus on building a great experience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;